export default __webpack_public_path__ + "static/media/watch.5d2cadac.csv";